import { Component } from '@verndale/core';
import { animate, AnimationControls } from 'motion';
import { EventBusSingleton } from '../animation/eventBus';
import { debounce } from '../helpers';
import { breakpoints } from '../helpers/variables';

class FeaturedCallToActions extends Component {
  MOTION_ZERO_DURATION = 0.000001;
  mainTimeline: AnimationControls | undefined;
  reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  initialDelay = 1;
  breakpointTabletLandscape = window.matchMedia(
    `(min-width: ${breakpoints.tabletLandscape}px)`
  );
  breakpointTablet = window.matchMedia(`(min-width: ${breakpoints.tablet}px)`);
  breakpointWide = window.matchMedia(`(min-width: ${breakpoints.wide}px)`);
  viewportWidth = window.innerWidth;
  hasMastheadPlayed: string | null;

  constructor(el: HTMLElement) {
    super(el);
    this.hasMastheadPlayed = localStorage.getItem(
      'manhattan_masthead-animation'
    );
    if (
      !this.reducedMotion.matches &&
      this.breakpointTablet.matches &&
      !this.hasMastheadPlayed
    ) {
      this.setInitialStyles();
    } else {
      (this.dom.imageContainer as HTMLElement).style.setProperty(
        '--clip',
        `${this.breakpointTabletLandscape.matches ? 160 : 0}px`
      );
    }

    if (!this.hasMastheadPlayed) {
      if (EventBusSingleton && this.dom.introAnimation) {
        EventBusSingleton.subscribe(
          'introAnimationOverlay:hide',
          this.animateImage.bind(this)
        );
      } else {
        this.animateImage();
      }
    }
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      callToActionsBlock: this.el.querySelector<HTMLElement>(
        '.featured-call-to-actions__info-block'
      ),
      imageContainer: this.el.querySelector<HTMLElement>(
        '.featured-call-to-actions__image-container'
      ),
      image: this.el.querySelector<HTMLElement>(
        '.featured-call-to-actions__image-container picture'
      ),
      introAnimation: document.querySelector<HTMLElement>(
        '.intro-animation-overlay'
      )
    };
  }

  addListeners() {
    window.addEventListener(
      'resize',
      debounce(this.handlePageResize.bind(this), 100)
    );
  }

  handlePageResize() {
    if (window.innerWidth !== this.viewportWidth) {
      this.setInitialStyles();
      this.animateImage(this.MOTION_ZERO_DURATION);
      this.viewportWidth = window.innerWidth;
    }
  }

  setInitialStyles() {
    (this.dom.imageContainer as HTMLElement).style.setProperty(
      '--clip',
      '100%'
    );
  }

  animateImage(duration?: number) {
    animate(
      progress => {
        (this.dom.imageContainer as HTMLElement).setAttribute(
          'style',
          `--clip:  calc(${100 - progress * 100}% + ${
            this.breakpointTabletLandscape.matches ? 160 : 0
          }px);`
        );
      },
      {
        delay: this.initialDelay,
        duration: duration ? duration : 0.75
      }
    );
    animate(
      this.dom.image as HTMLElement,
      {
        scale: [1.2, 1]
      },
      {
        delay: this.initialDelay,
        duration: duration ? duration : 1.25
      }
    );
  }
}

export default FeaturedCallToActions;
